import { FC, ReactNode } from 'react';
import { cx } from '@/utils/cx';

export type InfoTableRowProps = {
  label: string;
  value: ReactNode;
  labelClassName?: string;
  valueClassName?: string;
  stack?: boolean;
};

export const InfoTableRow: FC<InfoTableRowProps> = ({
  label,
  value,
  labelClassName,
  valueClassName,
  stack,
}) => (
  <div
    className={cx(
      'border-b border-gray-200 py-3 text-sm font-medium',
      stack ? 'flex flex-col gap-1' : 'flex flex-row justify-between',
    )}
  >
    <div className={cx('text-gray-500', labelClassName)}>{label}</div>
    <div
      className={cx(
        stack && 'overflow-x-auto whitespace-nowrap',
        valueClassName,
      )}
    >
      {value}
    </div>
  </div>
);
